import React from 'react';
import { Text, Spacing, MessageBox, Icon } from '@reservamos/elements';
import { useTranslation } from 'react-i18next';

/**
 * Warning message shown in the Quick Checkout flow, between the payment form and
 * the "Finalizar compra" button, prompting the user to verify their data before
 * completing the purchase.
 * @returns {JSX.Element} Rendered warning message box.
 */
const QuickCheckoutWarning = () => {
  const { t } = useTranslation('purchase');

  return (
    <MessageBox borderColor="warning" borderRadius="L" roundCorners widthFull>
      <Spacing size="XS" alignItems="center">
        <Icon name="emoji Raised Hand" size="S" type="emojiRaisedHand" />
        <Text size="S" weight="semibold">
          {t('quick_checkout.warning_title')}
        </Text>
      </Spacing>
      <Text size="S">{t('quick_checkout.warning_body')}</Text>
    </MessageBox>
  );
};

export default QuickCheckoutWarning;
